import { render } from "./helpBox.vue?vue&type=template&id=0e6a7450&scoped=true&ts=true"
import script from "./helpBox.ts?vue&type=script&lang=ts"
export * from "./helpBox.ts?vue&type=script&lang=ts"

import "./helpBox.scss?vue&type=style&index=0&id=0e6a7450&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e6a7450"]])

export default __exports__